export default function filterRegionalBiddingDataFromApi(data, filters = {}) {
  if (!Array.isArray(data)) return { labels: [], datasets: [] }

  const {
    state, biddingType, startDate, endDate,
  } = filters

  function isDateInRange(dateStr) {
    if (!dateStr) return true
    if (startDate && dateStr < startDate) return false
    if (endDate && dateStr > endDate) return false
    return true
  }

  // Filtra conforme filtros
  const filtered = data.filter(item => {
    if (state && item.stateName !== state) return false
    if (biddingType && item.biddingType !== biddingType) return false
    if (!isDateInRange(item.date)) return false
    return true
  })

  // Agrupa por estado
  const grouped = {}
  filtered.forEach(item => {
    if (!grouped[item.stateName]) grouped[item.stateName] = []
    grouped[item.stateName].push(item)
  })

  const labels = Object.keys(grouped).sort()

  const totalRegistered = []
  const successRate = []
  const totalWonValue = []

  labels.forEach(estado => {
    const group = grouped[estado]

    const total = group.length
    const won = group.filter(i => i.phase === 'GANHOS')
    const totalWon = won.length
    const wonValue = won.reduce((sum, i) => sum + (i.itemCost || 0), 0)

    totalRegistered.push(total)
    successRate.push(total > 0 ? Number(((totalWon / total) * 100).toFixed(2)) : 0)
    totalWonValue.push(Number(wonValue.toFixed(2)))
  })

  return {
    labels,
    datasets: [
      {
        label: 'Licitações Registradas',
        backgroundColor: '#42A5F5',
        data: totalRegistered,
      },
      {
        label: 'Taxa de Sucesso (%)',
        backgroundColor: '#FFA726',
        data: successRate,
      },
      {
        label: 'Valor Total Ganho (R$)',
        backgroundColor: '#66BB6A',
        data: totalWonValue,
      },
    ],
  }
}
